export default function() {
  return !this.node();
}



//////////////////
// WEBPACK FOOTER
// ./~/d3-svg-legend/~/d3-selection/src/selection/empty.js
// module id = D2Jj
// module chunks = 0